import { change, reset, submit } from 'redux-form'
import { SaveButton } from '../../../../itrust_common/components/others'
import ExamPatientInfo from '../../exam/edit/ExamPatientInfo'
import { connect, useDispatch } from 'react-redux'
import { quickActionsReset } from '../../../../redux/actions/dashboard/quickActionActions'
import * as $ from 'jquery';
import { useState } from 'react'
import Alert from '../../../../itrust_common/components/Alert'
import PrescriptionNotes from './PrescriptionNotes'
import { reportDelete, reportEdit, reportReset, reportUpdate } from '../../../../redux/actions/reports/reportsActions'

function PrescriptionHeader(props) {
  const { patient, saving, prescription, editing, providers, userId } = props
  const dispatch = useDispatch()
  const [anonymousUser, setAnonymousUser] = useState(prescription.other_details?.staff_name || editing?.other_details?.staff_name || '')
  const [staffId, setStaffId] = useState(editing?.other_details?.staff_id || prescription.other_details?.staff_id || '')

  const handleResetData = () => {
    dispatch(reportReset())
    dispatch(quickActionsReset())
    setStaffId(null)
    setAnonymousUser('')
    dispatch(reportEdit({ showPrescriptionModal: false }))
  }

  const handlePrescriptionFromClose = (isDelete) => {
    if (!isDelete && prescription.id) {
      dispatch(change('PrescriptionForm', 'check_empty_prescription', true))
      setTimeout(() => dispatch(submit('PrescriptionForm')), 200);
    }
    if (isDelete) {
      setTimeout(() => {
        $('#prescription-modal').modal('hide');
        handleResetData()
        dispatch(reset('PrescriptionForm'));
      }, 700);
    }
  }

  const handlePrescriptionDelete = async () => {
    Alert.deleteConfirm('Are you sure you want to delete this prescription?',
      async (res) => {
        if (res) {
          await dispatch(reportDelete(prescription.id))
          handlePrescriptionFromClose(true)
        }
      }
    )
  }

  const handleSelectProvider = (data) => {
    if (data.staff_id) {
      setStaffId(data.staff_id)
      dispatch(change('PrescriptionForm', 'other_details.staff_id', data.staff_id))
    }
    else if (data.staff_name) {
      setAnonymousUser(data.staff_name)
      dispatch(change('PrescriptionForm', 'other_details.staff_name', data.staff_name))
    }
    setTimeout(() => dispatch(submit('PrescriptionForm')), 200);
  }

  const handlePrescriptionClear = () => {
    Alert.confirm('Are you sure you want to clear this prescription? This will remove all existing Eyeglasses and Lenses.',
      (res) => {
        dispatch(change('PrescriptionForm', 'finalized_lenses_attributes', []))
        dispatch(change('PrescriptionForm', 'finalized_glasses_attributes', []))
        dispatch(change('PrescriptionForm', 'clear_prescription', true))
        setTimeout(() => dispatch(submit('PrescriptionForm')), 200);
      })
  }

  const handlePrescriptionUpdate = async (data) => {
    await dispatch(reportUpdate(data, { include: '*' }))
    return true
  }

  return (
    <>
      <div className="fixed-container-modal py-5 pr-8 bg-light patient-exam-form-fixed">
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div>
            <h5 className="mr-2">Prescription Form</h5>
            {prescription.id && <span className="ml-1"><strong>ID:</strong> {prescription.id}</span>}
          </div>
          <div className="d-flex align-items-center">
            <button className="btn btn-outline-danger ml-5" onClick={() => handlePrescriptionClear()}>Clear</button>
            {prescription.id && <button className="btn btn-outline-danger ml-5" onClick={() => handlePrescriptionDelete()}>Delete Prescription</button>}
            <SaveButton handleOnClick={() => dispatch(submit('PrescriptionForm'))} label="Save Prescription" saving={saving} wrapperClasses="ml-5" />
            {prescription.status === "finalized" ?
              <button type="button" className="btn btn-success ml-5 text-white">Finalized</button> :
              <button type="button" className="btn btn-outline-primary ml-5" onClick={() => handlePrescriptionUpdate({ ...prescription, status: 'finalized' })}>Finalize</button>
            }
            <button className="btn btn-outline-primary ml-5" onClick={() => handlePrescriptionFromClose()}>Close</button>
          </div>
        </div>
      </div>

      <div className="bg-white w-100 d-flex rounded shadow-sm mb-5 mt-10">
        <ExamPatientInfo patient={patient} />
        <div className="border-left border-light p-5 w-100">
          <div className="row align-items-center">
            <div className='col-3'>
              {(prescription.other_details?.staff_id || editing?.other_details?.staff_id) ? <div className="form-group">
                <label htmlFor="prescriptionProvider">Select Provider</label>
                <select className="form-control" id="prescriptionProvider" value={staffId} onChange={(e) => handleSelectProvider({ staff_id: e.target.value })}>
                  {providers.map((item) => <option value={item.id}>{item.name}</option>)}
                </select>
              </div> : <>
                {(prescription.other_details?.staff_name || editing?.other_details?.staff_name) && <div>
                  <label>Add Anonymous Provider</label>
                  <input
                    type="text"
                    value={anonymousUser}
                    className='form-control font-control-sm'
                    onChange={(e) => setAnonymousUser(e.target.value)}
                    onBlur={(e) => handleSelectProvider({ staff_name: e.target.value })}
                  />
                </div>}
              </>}
            </div>
            <PrescriptionNotes
              prescription={prescription}
              handlePrescriptionUpdate={handlePrescriptionUpdate}
              userId={userId}
            />
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  const { dashboard: { quickAction }, currentStore, reports: { saving, report, editing }, auth: { user } } = state

  return {
    patient: quickAction.patient,
    prescription: report,
    saving,
    editing,
    providers: currentStore.staffs,
    userId: user.id
  }
}

export default connect(mapStateToProps)(PrescriptionHeader);